import { labelDragYourFile, supportedExt } from "_constants";

export const HeaderTemplate = ({ options, visibleHeader, error }: any) => {
  const { className, chooseButton } = options;

  return visibleHeader ? (
    <div className={`${className} ${error ? 'error': ''}`}>
      <div className="height-100 flex-container justify-center align-center column gap-16">
        <span className="text-base-regular">
          {labelDragYourFile + " "}
          {chooseButton}
        </span>
        <span className="text-sm">{supportedExt}</span>
      </div>
    </div>
  ) : (
    <></>
  );
};
